// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
import StudioForm from 'components/forms/StudioForm';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/css';
import saveOrganization from 'ApolloClient/Mutations/saveOrganization';
import { graphql } from 'react-apollo';
import message from 'antd/lib/message';

class StudioFormArea extends React.PureComponent {
  state = {
    loading: false,
  };

  handleSubmit = async values => {
    this.setState({ loading: true });
    // do save studio mutation here
    let variables = {
      _id: this.props.studio._id,
      params: {
        email: values.email,
        title: values.title,
        street1: values.street1,
        street2: values.street2,
        website: values.website,
        phone: values.phone,
        description: values.description,
        country: values.country,
        state: values.state,
        city: values.city,
        zip: values.zip,
        salesTax: values.salesTax,
        currency: values.currency,
        image: values.image,
      },
    };

    try {
      await this.props.saveOrganization({ variables });
      this.setState({ loading: false });
      message.success('Studio profile saved!');
    } catch (err) {
      return console.log(err);
    }
  };

  render() {
    const { studio } = this.props;
    return (
      <div>
        <div style={{ position: 'relative' }}>
          <SectionHeader>MY STUDIO</SectionHeader>
        </div>
        <div style={{ width: 550, maxWidth: '100%' }}>
          <Card bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <StudioForm onOkText="Save" studio={studio} loading={this.state.loading} handleSubmit={this.handleSubmit} />
          </Card>
        </div>
      </div>
    );
  }
}

export default graphql(saveOrganization, { name: 'saveOrganization' })(StudioFormArea);



// WEBPACK FOOTER //
// ./src/routes/app-studio/StudioFormArea/index.js